import { BookMessageConverter, ParserMessageConverter } from './services/message-converter.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParserPluginLinkComponent } from './components/plugin-link/parser-plugin-link.component';
import { WINDOW_MESSAGE_CONVERTERS } from '@uxdf/direct-shared-lib';

@NgModule({
  imports: [CommonModule],
  declarations: [ParserPluginLinkComponent],
  exports: [ParserPluginLinkComponent],
  providers: [
    {
      provide: WINDOW_MESSAGE_CONVERTERS,
      useClass: ParserMessageConverter,
      multi: true
    },
    {
      provide: WINDOW_MESSAGE_CONVERTERS,
      useClass: BookMessageConverter,
      multi: true
    }
  ]
})
export class ParserModule {}
